<template>
  <v-container fluid class="pa-8 fill-height">
    <v-row justify="center">
      <v-col cols="4" class="d-flex flex-column justify-center align-stretch">
        <v-card>
          <v-toolbar elevation="0" dark color="primary">
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>

            <v-form ref="loginForm">

              <template v-if="type === 'paciente'">
                <span class="font-weight-medium">Paciente</span>

                <v-text-field
                  v-model="credentials.numeroExame"
                  :rules="[rules.required]"
                  label="Número do Protocolo"
                  hide-details="auto"
                >
                </v-text-field>
                <v-text-field
                  v-model="credentials.password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword = !showPassword"
                  :rules="[rules.required]"
                  label="Senha"
                  hide-details="auto"
                  class="mb-1"
                  @keypress.enter="login"
                >
                </v-text-field>
              </template>
              <template v-else-if="type === 'medico'">
                <span class="font-weight-medium">Médico</span>

                <br/>
                <span>Cadastro no Conselho Regional</span>

                <v-row no-gutters>

                  <v-col>
                    <v-combobox
                      v-model="conselho"
                      :rules="[rules.required]"
                      :items="conselhos"
                      hide-details="auto"
                      label="Sigla"
                    >
                    </v-combobox>
                  </v-col>

                  <v-col>
                    <v-text-field
                      v-model="codMedico"
                      :rules="[rules.required]"
                      label="Número"
                      hide-details="auto"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col>
                    <v-combobox
                      v-model="uf"
                      :rules="[rules.required]"
                      :items="ufs"
                      hide-details="auto"
                      label="UF"
                    >
                    </v-combobox>
                  </v-col>

                </v-row>

                <v-text-field
                  v-model="credentials.password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword = !showPassword"
                  :rules="[rules.required]"
                  label="Senha"
                  hide-details="auto"
                  @keypress.enter="login"
                >
                </v-text-field>

                <a
                  v-if="conselho && codMedico && uf"
                  @click="requestPasswordReset"
                  class="text-caption text-decoration-underline primary--text"
                >
                  Esqueci minha senha
                </a>
                <div v-if="resetting">
                  Te enviamos um e‑mail com sua nova senha.
                </div>
              </template>
              <template v-else-if="type === 'empresa'">
                <span class="font-weight-medium">Empresa</span>

                <v-text-field
                  v-model="credentials.codConveniada"
                  :rules="[rules.required]"
                  label="Código"
                  hide-details="auto"
                >
                </v-text-field>
                <v-text-field
                  v-model="credentials.password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword = !showPassword"
                  :rules="[rules.required]"
                  label="Senha"
                  hide-details="auto"
                  class="mb-1"
                  @keypress.enter="login"
                >
                </v-text-field>

                <a
                  v-if="credentials.codConveniada"
                  @click="requestPasswordReset"
                  class="text-caption text-decoration-underline primary--text"
                >
                  Esqueci minha senha
                </a>
                <div v-if="resetting">
                  Te enviamos um e‑mail com com sua nova senha.
                </div>
              </template>

            </v-form>

          </v-card-text>

          <v-card-actions>
            <v-btn @click="$router.push('/')">
              <v-icon left>mdi-arrow-left</v-icon>
              Voltar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="login" dark color="primary" :loading="loginLoading">
              <v-icon left>mdi-check</v-icon>
              Entrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="6" class="d-flex flex-column justify-center align-stretch">
        <template v-if="type === 'paciente'">
          <v-card class="px-4">
            <v-card-text class="black--text">
              <span class="font-weight-medium">SIGA AS INSTRUÇÕES:</span>
              <ol>
                <li>Digite o número de protocolo, com ou sem pontos.</li>
                <li>Digite a sua senha.</li>
                <li>Clique no botão “ENTRAR”.</li>
              </ol>

              <br/>

              <span class="font-weight-medium">ACESSO RESTRITO E PROTEGIDO</span>
              <br/>
              Para sua maior comodidade e segurança, apenas o portador do número de protocolo e da senha de internet pode acessar os resultados.
              <br/>
              <br/>
              Em caso de dúvidas, entre em contato com o nosso atendimento:
              <a style="white-space: nowrap;" href="tel:+551131356880">11 3135-6880</a>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="type === 'medico'">
          <v-card class="px-4">
            <v-card-text class="black--text">
              <span class="font-weight-medium">SIGA AS INSTRUÇÕES:</span>
              <ol>
                <li>
                  Usar a sigla do seu conselho regional profissional. Caso não a encontre, digitá-la.
                  Para médicos, a sigla CRM é fixa.
                </li>
                <li>Digite o número do CRM sem o ponto.</li>
                <li>Escolha a unidade da federação (UF) do conselho regional profissional. Para o Estado de São Paulo, SP é fixo.</li>
                <li>
                  No primeiro acesso, você deverá clicar em “Esqueci a minha senha”. E uma nova senha será
                  enviada para o seu e‑mail cadastrado anteriormente em nossa base de dados.
                </li>
                <li>
                  Depois basta digitar essa senha recebida no e‑mail e clicar no botão “ENTRAR”
                  para acessar os resultados de exames dos seus pacientes.
                </li>
              </ol>

              <br/>

              <span class="font-weight-medium">OBSERVAÇÕES:</span>
              <ol>
                <li>
                  Para alteração de e‑mail e/ou dúvidas, você deverá entrar em contato com “Atendimento aos consultórios” pelo
                  <a style="white-space: nowrap;" href="tel:+551131356888">11 3135-6888</a> ou <a style="white-space: nowrap;" href="tel:+5511933323339">11 9 3332-3339</a>.
                </li>
                <li>
                  Não se esqueça: toda vez que você clicar em “Esqueci a minha senha”,
                  uma nova senha será gerada e enviada para o seu e‑mail. O ideal é anotá-la.
                </li>
              </ol>

              <br/>

              <span class="font-weight-medium">ACESSO RESTRITO E PROTEGIDO</span>
              <br/>
              Para sua maior comodidade e segurança, apenas o portador da senha de internet pode acessar os resultados.
            </v-card-text>
          </v-card>
        </template>
        <template v-if="type === 'empresa'">
          <v-card class="px-4">
            <v-card-text class="black--text">
              <span class="font-weight-medium">SIGA AS INSTRUÇÕES:</span>
              <ol>
                <li>
                  Digite o “Código” que lhe enviamos. Esse “Código” é gerado internamente pela Genoa/LPCM.
                </li>
                <li>
                  No primeiro acesso, você deverá clicar em “Esqueci minha senha”. E uma nova senha será enviada para
                  o(s) e‑mail(s) do(s) responsável(is) cadastrados anteriormente em nossa base de dados.
                </li>
                <li>
                  No caso de produtoras, o primeiro acesso será feito com uma senha padrão.
                  Depois, é necessário alterar essa senha padrão em “Esqueci minha senha”.
                </li>
                <li>
                  Depois basta digitar essa senha recebida no e‑mail e clicar no botão “ENTRAR”
                  para acessar os resultados de exames dos seus clientes.
                </li>
              </ol>

              <br/>

              <span class="font-weight-medium">OBSERVAÇÕES:</span>
              <ol>
                <li>
                  Para solicitar o seu “Código” (caso não o tenha recebido), alterar o e‑mail e/ou dúvidas,
                  você deverá entrar em contato com os números de telefones:
                  <br/>
                  <a style="white-space: nowrap;" href="tel:+5519993749191">19 9 9374-9191</a>/
                  <a style="white-space: nowrap;" href="tel:+551131356888">11 3135-6888</a>/
                  <a style="white-space: nowrap;" href="tel:+5511933323339">11 9 3332-3339</a>
                  > se você for de Apoio, Hospitais, Laboratórios ou Clínicas.
                  <br/>
                  <a style="white-space: nowrap;" href="tel:+5511974166928">11 9 7416-6928</a>/
                  <a style="white-space: nowrap;" href="tel:+5511963280213">11 9 6328-0213</a>/
                  <a style="white-space: nowrap;" href="tel:+5511945641814">11 9 4564-1814</a>
                  > se for de Produtoras ou Empresas.
                </li>
                <li>
                  Não se esqueça: toda vez que você clicar em “Esqueci a minha senha”,
                  uma nova senha será gerada e enviada para o seu e‑mail. O ideal é anotá-la.
                </li>
              </ol>

              <br/>

              <span class="font-weight-medium">ACESSO RESTRITO E PROTEGIDO</span>
              <br/>
              Para sua maior comodidade e segurança, apenas o portador da senha de internet pode acessar os resultados.
            </v-card-text>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <form style="display: none;" action="https://motion.genoabiotec.com.br/portal/actions/vedocs/historicoPaciente" method="post">
      <div>
        <div>
          <input name="origem" value="VeLAB">
          <input name="protocolo" v-model="credentials.numeroExame">
          <input name="senha" v-model="credentials.password">
          <button ref="legacySystemIntegrationBtn" type="submit"></button>
        </div>
      </div>
    </form>
  </v-container>
</template>

<script>
import { resendPassword } from '@/services/auth'

export default {

  props: {
    type: {
      type: String,
      default: '',
      required: true
    }
  },

  data () {
    return {

      conselho: 'CRM',
      codMedico: '',
      uf: 'SP',

      credentials: {
        numeroExame: '',
        cadMed: '',
        codConveniada: '',
        password: ''
      },

      showPassword: false,

      loginLoading: false,

      resetting: false,

      rules: {
        required: value => !!value || 'Este campo é obrigatório',
        cnpj: value => (value && /^[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}-?[0-9]{2}$/.test(value)) || 'CNPJ inválido'
      }
    }
  },

  computed: {
    conselhos () {
      return [
        'CRM',
        'CRO'
      ]
    },
    ufs () {
      return [
        'AC',
        'AL',
        'AM',
        'AP',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MG',
        'MS',
        'MT',
        'PA',
        'PB',
        'PE',
        'PI',
        'PR',
        'RJ',
        'RN',
        'RO',
        'RR',
        'RS',
        'SC',
        'SE',
        'SP',
        'TO'
      ]
    }
  },

  watch: {

  },

  mounted () {
    this.$store.commit('clearCredentials')
  },

  methods: {

    async login () {
      if (this.$refs.loginForm.validate()) {
        this.loginLoading = true

        if (this.type === 'paciente' && this.credentials.numeroExame.length >= 12) {
          this.$set(this.credentials, 'numeroExame', this.credentials.numeroExame.replace(/\./g, ''))
          await this.$nextTick()
          this.$refs.legacySystemIntegrationBtn.click()
          return
        }

        if (this.type === 'medico') {
          this.$set(this.credentials, 'cadMed', this.conselho + this.codMedico + this.uf)
        }
        this.$store.commit('saveCredentials', this.credentials)

        try {
          const result = await this.$store.dispatch('validateCredentials')

          if (!result?.success) {
            return
          }

          this.$router.push({ name: this.type })
        } catch (error) {
          console.error(error)
        } finally {
          this.loginLoading = false
        }
      }
    },

    async requestPasswordReset () {
      if (this.type === 'medico') {
        this.$set(this.credentials, 'cadMed', this.conselho + this.codMedico + this.uf)
      }
      if (this.credentials.cadMed || this.credentials.codConveniada) {
        this.resetting = true
        console.log(await resendPassword(this.credentials))
      }
    }

  }

}
</script>

<style>

</style>
